import { useCallback, useContext } from 'react';
import ClientContext from '@/contexts/client.context';
import Portal from '@/utils/create-portal';
import theme from '@/utils/styles-variables';
import useBetterMediaQuery from '@/utils/useBetterMediaQuery';

// Components
import Modal from '../Modal';
import EnrollButton from '@/app/_components/core/EnrollButton';
import useVideoTracking from '@/utils/useVideoTracking';

// Styles
import { CloseButton, IconClose, ButtonWrapper } from './styles';

const VideoPlayerModal = ({ modalIsOpen, closeModal, videoURL, modalEnrollButton }) => {
  const { onVideoExit, ...trackVideo } = useVideoTracking({ src: videoURL });
  const { client, openModal } = useContext(ClientContext);
  const isMobile = useBetterMediaQuery(`(max-width: ${theme.breakpoints.max_sm}px)`);

  const onClose = useCallback(() => {
    onVideoExit();
    closeModal();
  }, [onVideoExit, closeModal]);

  const desktopStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      zIndex: '1000000',
    },
    content: {
      backgroundColor: 'transparent',
      border: 'none',
      position: 'absolute',
      width: '90%',
      maxWidth: '70vw',
      top: '55%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      padding: 0,
    },
  };

  const mobileStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      zIndex: '1000000',
    },
    content: {
      alignContent: 'center',
      display: 'grid',
      justifyItems: 'center',
      border: 'none',
      overflow: 'initial',
      backgroundColor: 'transparent',
      padding: 0,
      inset: 0,
    },
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={onClose}
      style={isMobile ? mobileStyles : desktopStyles}
    >
      {modalIsOpen && (
        <Portal portalId="close-button-video-modal">
          <CloseButton type="button" onClick={onClose}>
            <IconClose alt="" src="/icons/circle-close.svg" width="20" height="20" />
          </CloseButton>
        </Portal>
      )}
      <video controls autoPlay playsInline width="100%" {...trackVideo}>
        <source src={videoURL} />
      </video>

      {modalEnrollButton && (
        <ButtonWrapper>
          <EnrollButton
            id={'video-modal-enroll-button'}
            isActive={client?.isActive}
            buttonLocation={'video-modal-enroll-button'}
            openModal={() =>
              openModal({
                buttonText: modalEnrollButton?.buttonLabel,
                buttonLocation: 'video-modal',
              })
            }
            client={client}
            buttonLabel={modalEnrollButton?.buttonLabel}
            product={client?.product}
            redirectToApp={client?.redirectToApp}
          />
        </ButtonWrapper>
      )}
    </Modal>
  );
};

export default VideoPlayerModal;
